var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.faqs.length)?_c('Paper',{attrs:{"id":"booth-faqs","header":_vm.$t('vfair.companies.faq')}},[_c('div',{staticClass:"p-5"},_vm._l((_vm.faqs),function(qa){return _c('article',{key:qa.id},[_c('h2',[_vm._v(_vm._s(qa.question))]),_c('p',{domProps:{"innerHTML":_vm._s(qa.answer)}})])}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }